import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/site";
import ArticleCard from "@/components/feature/ArticleCard";

export default function CategoryExploreSection() {
  const [active, setActive] = useState(categories[0].slug);
  const current = categories.find((c) => c.slug === active) ?? categories[0];
  const list = articles.filter((a) => a.category === active);

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 rounded-md bg-primary-100 px-2.5 py-1 text-xs font-semibold text-primary-800">
              <i className="ri-layout-grid-line" />
              栏目逛一逛
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              按栏目找到你的好料
            </h2>
          </div>
          <Link
            to={`/category/${current.slug}`}
            className="inline-flex items-center gap-1 text-sm font-semibold text-primary-700 transition-colors hover:text-primary-900 whitespace-nowrap"
          >
            进入「{current.name}」栏目 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* 栏目切换 */}
        <div className="mt-8 flex gap-2 overflow-x-auto kn-scroll pb-1" role="tablist" aria-label="栏目切换">
          {categories.map((c) => {
            const on = active === c.slug;
            return (
              <button
                key={c.slug}
                role="tab"
                aria-selected={on}
                type="button"
                onClick={() => setActive(c.slug)}
                className={`inline-flex shrink-0 items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                  on
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
                }`}
              >
                <i className={c.icon} />
                {c.name}
              </button>
            );
          })}
        </div>

        {/* 栏目介绍条 */}
        <p className="mt-6 max-w-3xl rounded-lg border-l-4 border-secondary-400 bg-secondary-50 px-4 py-3 text-sm leading-7 text-foreground-700">
          <strong className="text-secondary-900">{current.name}：</strong>
          {current.desc}
        </p>

        {/* 卡片网格 */}
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.slice(0, 4).map((a) => (
            <ArticleCard key={a.slug} article={a} />
          ))}
        </div>

        {list.length > 4 && (
          <div className="mt-8 text-center">
            <Link
              to={`/category/${current.slug}`}
              className="inline-flex h-11 items-center gap-2 rounded-md border border-primary-300 px-6 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50 whitespace-nowrap"
            >
              在「{current.name}」栏目查看更多好料
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}